import "./styles/globals.css";
import { makeStyles } from "@fluentui/react-components";
import { useState } from "react";
import { getSessionUsername, setSessionUsername } from "./api/client";
import { DebugConsole } from "./components/DebugConsole";
import { FeatureFlagsProvider } from "./context/FeatureFlagsContext";
import LoginForm from "./components/LoginForm";
import VariantCShell from "./variant-c/VariantCShell";

const useStyles = makeStyles({
  root: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "var(--background)",
    fontFamily: "var(--font-sans)",
  },
});

export default function App() {
  const styles = useStyles();

  const savedUsername = getSessionUsername();
  const [username, setUsername] = useState<string>(savedUsername || "");
  const [loggedIn, setLoggedIn] = useState<boolean>(!!savedUsername);

  const handleLoginSuccess = (user: string) => {
    setSessionUsername(user);
    setUsername(user);
    setLoggedIn(true);
  };

  return (
    <div className={styles.root}>
      {loggedIn ? (
        <FeatureFlagsProvider>
          <VariantCShell userIdentifier={username || null} />
        </FeatureFlagsProvider>
      ) : (
        <LoginForm onLoginSuccess={handleLoginSuccess} />
      )}
      <DebugConsole />
    </div>
  );
}
